export default ({request}) => ({
  changeOrderDemandFabricListApi(data = {}) {
    return request({
      url: '/factory/changeOrderDemandFabric/list',
      method: 'post',
      data,
    })
  },
  changeOrderDemandFabricDetailApi(data = {}) {
    return request({
      url: '/factory/changeOrderDemandFabric/detail',
      method: 'post',
      data,
    })
  },
  changeOrderDemandFabricBatchSaveApi(data = {}) {
    return request({
      url: '/factory/changeOrderDemandFabric/batchSave',
      method: 'post',
      data,
    })
  },
  changeOrderDemandFabricSaveApi(data = {}) {
    return request({
      url: '/factory/changeOrderDemandFabric/save',
      method: 'post',
      data,
    })
  },
  changeOrderDemandFabricDelApi(data = {}) {
    return request({
      url: '/factory/changeOrderDemandFabric/del',
      method: 'post',
      data,
    })
  },
})
